import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useToast } from "../context/ToastContext";
import api from "../lib/api.ts";
import leftbgimg from "../assets/leftbg.jpg";
import bgimg from "../assets/loginbg.png";

const ForgotPassword = () => {
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: "" } });

  const onSubmit = async ({ email }) => {
    setIsLoading(true);
    try {
      await api.post(`/auth/forgot-password`, { email });
      showSuccess("   A reset link has been sent to your email.");
    } catch (e) {
      showError(
        "Something went wrong while sending the reset email. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className='min-h-[94vh] p-2 flex items-center justify-center bg-cover bg-center'
      style={{ backgroundImage: `url(${bgimg})` }}
    >
      <div className='bg-white/20 backdrop-blur-lg w-full max-w-7xl rounded-3xl shadow-2xl border-[3px] border-white relative overflow-hidden'>
        <div className='flex flex-col md:flex-row min-h-[800px] relative'>
          {/* Left side - image panel */}
          <div className='md:w-1/2 relative text-white p-10 overflow-hidden'>
            <div
              className='absolute inset-0 bg-cover bg-center'
              style={{ backgroundImage: `url(${leftbgimg})` }}
            >
              <div className='absolute inset-0 bg-black opacity-20'></div>
            </div>
            <div className='relative z-10 text-center md:pt-20'>
              <h2 className='text-[30px] md:text-[60px] font-semibold mb-2'>
                Forgot Password
              </h2>
              <p className='text-lg md:text-[20px] text-white/90 mb-6'>
                Enter your email to receive a reset link
              </p>
            </div>
          </div>

          {/* Right side - form */}
          <div className='md:w-1/2 bg-white/70 backdrop-blur-md p-10 flex items-center justify-center  overflow-y-auto max-h-[800px]'>
            <form onSubmit={handleSubmit(onSubmit)} className='w-full max-w-md'>
              <div className='space-y-3'>
                <h3 className='text-2xl md:text-[28px] font-bold mb-1 text-[#131313]'>
                  Forgot your password?
                </h3>
                <p className='text-[#13131399] pb-6 text-sm md:text-[16px]'>
                  Enter the email you use to sign in. We'll email you a link to
                  reset your password.
                </p>
              </div>

              <div className='mb-4'>
                <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
                  Email address
                </label>
                <input
                  type='email'
                  placeholder='your@email.com'
                  className={`w-full px-3 py-3 border ${
                    errors.email ? "border-red-400" : "border-[#13131399]"
                  } rounded-lg bg-white placeholder:text-text-[rgba(19,19,19,1)] focus:outline-none`}
                  {...register("email", {
                    required: "Please enter your email address.",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address.",
                    },
                  })}
                />
                {errors.email && (
                  <p className='mt-1 text-sm text-red-500'>
                    {errors.email.message}
                  </p>
                )}
              </div>

              <div className='flex items-center justify-end gap-2'>
                <a
                  href='/login'
                  className='px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50'
                >
                  Cancel
                </a>
                <button
                  type='submit'
                  disabled={isLoading}
                  className='px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-60'
                >
                  {isLoading ? "Sending..." : "Send reset link"}
                </button>
              </div>

              <p className='text-xs text-gray-500 mt-4'>
                Didn’t get the email? Check your spam folder or try again.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
